import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class DeliveryService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getShipment(shipmentId) {
    const result = await this.apiService.get(`/delivery/shipments/${shipmentId}`);
    return result;
  }

  async getDeliveryStatuses() {
    const result = await this.apiService.get(`/delivery/statuses`);
    return result;
  }

  async getShipments(filters) {
    const newFilters = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value === null || value === undefined) {
        return acc;
      }

      if (key === 'period') {
        const newValue = value;
        if (!value.dateEnd) {
          newValue.dateEnd = value.dateStart;
        }
        const { id, ...rest } = newValue;

        return { ...acc, [key]: rest };
      }

      if (
        key === 'status' ||
        key === 'customers' ||
        key === 'offices' ||
        key === 'customers' ||
        key === 'constructions' ||
        key === 'team'
      ) {
        return { ...acc, [key]: value };
      }

      return acc;
    }, {});

    const result = await this.apiService.post(`/delivery/shipments`, newFilters);
    return result;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), DeliveryService, 0);

export default DeliveryService;
